export const COUNTRY_CODES = {
  BE: { code: '+32', name: 'Belgium' },
  SA: { code: '+966', name: 'Saudi Arabia' },
  MY: { code: '+60', name: 'Malaysia' },
  AE: { code: '+971', name: 'UAE' },
  OM: { code: '+968', name: 'Oman' },
  BH: { code: '+973', name: 'Bahrain' },
  KW: { code: '+965', name: 'Kuwait' },
  QA: { code: '+974', name: 'Qatar' },
  IN: { code: '+91', name: 'India' },
};
